import { useState, useEffect, useCallback } from 'react';
import { createHankoClient } from '../utils/hanko';

export function usePasskeys() {
  // Lazy-initialized so fetchPasskeys has no synchronous work (and thus no
  // synchronous setState path) before its first await.
  const [hanko] = useState(() => createHankoClient());
  const [passkeyCount, setPasskeyCount] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchPasskeys = useCallback(async () => {
    try {
      const user = await hanko.getUser();
      // Passkeys are stored in user.passkeys
      const passkeys = user.passkeys || [];
      setPasskeyCount(passkeys.length);
    } catch (error) {
      console.error('Failed to fetch passkeys:', error);
      setPasskeyCount(0);
    } finally {
      setIsLoading(false);
    }
  }, [hanko]);

  useEffect(() => {
    // Microtask defer keeps every setState in fetchPasskeys off the effect's
    // synchronous path (react-hooks/set-state-in-effect).
    void Promise.resolve().then(fetchPasskeys);
  }, [fetchPasskeys]);

  return {
    passkeyCount,
    hasPasskeys: passkeyCount !== null && passkeyCount > 0,
    isLoading,
    refetch: fetchPasskeys,
  };
}
